"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*export interface ICursorList<T> extends IList<T> {
  /!*
   * Whether or not there are more elements available after this set. If false, this set comprises the end of the list.
   * *!/
  has_more: boolean;
}

export interface ListCursorOptionsCreated extends IListOptionsCreated {
  /!*
   * A cursor for use in pagination. starting_after is an object ID that defines your place in the list. For instance, if you make a list request and receive 100 objects, ending with obj_foo, your subsequent call can include starting_after=obj_foo in order to fetch the next page of the list.
   * *!/
  starting_after?: string;

  /!*
   * A cursor for use in pagination. ending_before is an object ID that defines your place in the list. For instance, if you make a list request and receive 100 objects, starting with obj_bar, your subsequent call can include ending_before=obj_bar in order to fetch the previous page of the list.
   * *!/
  ending_before?: string;
}*/
